export default "__VITE_ASSET__8460c983__"